import { Injectable } from "@angular/core";
import { AbstractService } from "../core/AbstractService";
import { TypeModePassationReq } from "../data/http/requests/typepassation.req";
import { TypeModePassationRes } from "../data/http/responses/typepassation.res";
import { HttpClient } from "@angular/common/http";
import { AuthService } from "./auth/auth.service";
import { Injector } from "@angular/core";
import { AppService } from "../core/app.service";
import { env } from "../../env/env";


@Injectable({
    providedIn: 'root'
})
export class TypeModePassationMarcheService extends AbstractService<TypeModePassationReq, TypeModePassationRes> {
    constructor(http: HttpClient, injector: Injector, appService: AppService) {
        // cookies service might not be available in all contexts; pass null and let AbstractService use AppService
        super(`${env.apiUrl}type-passation-marche`, http, null, appService ); 
    }
}